module.exports = __webpack_public_path__ + "static/media/saritayadav.92d63dcb.jpg";